import { i18n } from '@/locales';
import { convertCase } from '@/utils';
const lc = 'views.user_management.';
const searchFieldOptionsTypeCode = [
    'USER_ID',
    'NAME',
];
export default searchFieldOptionsTypeCode.map((code) => {
    const lowerCasedCode = code.toLowerCase();
    const snakeToCamelCode = convertCase(code, 'snake', 'camel');
    return ({
        text: i18n.t(`${lc}${lowerCasedCode}`),
        value: snakeToCamelCode,
        field: snakeToCamelCode,
    });
});
